package `fun`.adaptive.ui.builtin

import `fun`.adaptive.resource.string.Strings
import `fun`.adaptive.resource.string.StringStoreResourceSet
import `fun`.adaptive.resource.file.FileResource
import `fun`.adaptive.resource.LanguageQualifier

val commonMainStringsStringStore0 =
    StringStoreResourceSet(
        name = "strings",
        FileResource("/fun.adaptive.ui.builtin/strings/strings-en.avs", setOf(LanguageQualifier("en"))),
        FileResource("/fun.adaptive.ui.builtin/strings/strings.avs", setOf())
    )

val Strings.account
    get() = commonMainStringsStringStore0.get(0)

val Strings.april
    get() = commonMainStringsStringStore0.get(1)

val Strings.aprilAbr
    get() = commonMainStringsStringStore0.get(2)

val Strings.august
    get() = commonMainStringsStringStore0.get(3)

val Strings.augustAbr
    get() = commonMainStringsStringStore0.get(4)

val Strings.cancel
    get() = commonMainStringsStringStore0.get(5)

val Strings.collapseAll
    get() = commonMainStringsStringStore0.get(6)

val Strings.copied
    get() = commonMainStringsStringStore0.get(7)

val Strings.copyToClipboard
    get() = commonMainStringsStringStore0.get(8)

val Strings.december
    get() = commonMainStringsStringStore0.get(9)

val Strings.decemberAbr
    get() = commonMainStringsStringStore0.get(10)

val Strings.edit
    get() = commonMainStringsStringStore0.get(11)

val Strings.executionError
    get() = commonMainStringsStringStore0.get(12)

val Strings.expandAll
    get() = commonMainStringsStringStore0.get(13)

val Strings.february
    get() = commonMainStringsStringStore0.get(14)

val Strings.februaryAbr
    get() = commonMainStringsStringStore0.get(15)

val Strings.friday
    get() = commonMainStringsStringStore0.get(16)

val Strings.fridayOneLetter
    get() = commonMainStringsStringStore0.get(17)

val Strings.hide
    get() = commonMainStringsStringStore0.get(18)

val Strings.home
    get() = commonMainStringsStringStore0.get(19)

val Strings.january
    get() = commonMainStringsStringStore0.get(20)

val Strings.januaryAbr
    get() = commonMainStringsStringStore0.get(21)

val Strings.july
    get() = commonMainStringsStringStore0.get(22)

val Strings.julyAbr
    get() = commonMainStringsStringStore0.get(23)

val Strings.june
    get() = commonMainStringsStringStore0.get(24)

val Strings.juneAbr
    get() = commonMainStringsStringStore0.get(25)

val Strings.march
    get() = commonMainStringsStringStore0.get(26)

val Strings.marchAbr
    get() = commonMainStringsStringStore0.get(27)

val Strings.may
    get() = commonMainStringsStringStore0.get(28)

val Strings.mayAbr
    get() = commonMainStringsStringStore0.get(29)

val Strings.monday
    get() = commonMainStringsStringStore0.get(30)

val Strings.mondayOneLetter
    get() = commonMainStringsStringStore0.get(31)

val Strings.notSet
    get() = commonMainStringsStringStore0.get(32)

val Strings.november
    get() = commonMainStringsStringStore0.get(33)

val Strings.novemberAbr
    get() = commonMainStringsStringStore0.get(34)

val Strings.october
    get() = commonMainStringsStringStore0.get(35)

val Strings.octoberAbr
    get() = commonMainStringsStringStore0.get(36)

val Strings.ok
    get() = commonMainStringsStringStore0.get(37)

val Strings.saturday
    get() = commonMainStringsStringStore0.get(38)

val Strings.saturdayOneLetter
    get() = commonMainStringsStringStore0.get(39)

val Strings.save
    get() = commonMainStringsStringStore0.get(40)

val Strings.september
    get() = commonMainStringsStringStore0.get(41)

val Strings.septemberAbr
    get() = commonMainStringsStringStore0.get(42)

val Strings.signOut
    get() = commonMainStringsStringStore0.get(43)

val Strings.sunday
    get() = commonMainStringsStringStore0.get(44)

val Strings.sundayOneLetter
    get() = commonMainStringsStringStore0.get(45)

val Strings.thursday
    get() = commonMainStringsStringStore0.get(46)

val Strings.thursdayOneLetter
    get() = commonMainStringsStringStore0.get(47)

val Strings.tuesday
    get() = commonMainStringsStringStore0.get(48)

val Strings.tuesdayOneLetter
    get() = commonMainStringsStringStore0.get(49)

val Strings.wednesday
    get() = commonMainStringsStringStore0.get(50)

val Strings.wednesdayOneLetter
    get() = commonMainStringsStringStore0.get(51)